import { useEffect, useRef } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import SocketContext from "./SocketContext";
import { useUser } from "../UserContext";
import { useGetCurrentSession } from "@/apis/hooks/auth/session";
import { useQueryClient } from "../HttpQueryContext";

export function SocketProvider({ children }) {
  const { user, accessToken: token } = useUser();
  const queryClient = useQueryClient();

  const getCurrentSessionApi = useGetCurrentSession({
    options: { enabled: false },
  });

  const echoRef = useRef(null);

  useEffect(() => {
    if (!user || !token) return;

    if (!echoRef.current) {
      window.Pusher = Pusher;

      echoRef.current = new Echo({
        broadcaster: "reverb",
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
        wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
        forceTLS: true,
        enabledTransports: ["ws", "wss"],
        authEndpoint: "/broadcasting/auth",
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      });
    }

    const echo = echoRef.current;

    const channel = echo.private(`user.${user.id}`);

    channel.listen(".SessionTerminated", (event) => {
      const matchTokenId = token.match(/\d+/);
      const tokenId = matchTokenId ? parseInt(matchTokenId[0], 10) : null;

      queryClient.invalidateQueries({ queryKey: ["Auth::Session::GetActiveSessions"] });

      if (event.tokenId == tokenId) {
        getCurrentSessionApi?.refetch?.();
        console.info("🔴 Session terminated");
      }
    });

    return () => {
      echo.leave(`user.${user.id}`);
    };
  }, [user?.id, token]);

  return <SocketContext.Provider value={echoRef.current}>{children}</SocketContext.Provider>;
}
